import { render, staticRenderFns } from "./OnboardingGoals.vue?vue&type=template&id=372c6507&scoped=true&"
import script from "./OnboardingGoals.vue?vue&type=script&lang=js&"
export * from "./OnboardingGoals.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingGoals.vue?vue&type=style&index=0&id=372c6507&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c6507",
  null
  
)

export default component.exports